import axios from 'axios'
import { BUSCAR_ROTAS_IMPORTACAO, IMPORTAR_ROTAS,LIMPAR_ROTAS_IMPORTACAO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export function buscarRotasImportacao(codigo) {
  let url = `${URL}/rota/empresa/${codigo}/rotas`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: BUSCAR_ROTAS_IMPORTACAO,
      payload: response

    })
  );
}

export default function importarRotas(idEmpresaDestino, parametros) {  
  let url = `${URL}/rota/empresa-destino/${idEmpresaDestino}/importar`;
  return dispatch => axios.post(url, parametros, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: IMPORTAR_ROTAS,
      payload: response

    })
  );
}

export function limparBuscaRotasImportacao () {
  return {
    type: LIMPAR_ROTAS_IMPORTACAO,
  }
}
